import { PublicClientApplication } from '@azure/msal-browser';
import {
  IAppConfigurationProvider
} from '@dirootie-core/core-types';
import { MSalConfig } from '../../configuration/Configuration.types';
import { IAppModule, IServiceProvider } from './modules.types';
import { AuthenticationService ,AuthorizationService} from '../../packages/domain/iam';

export class AuthModule implements IAppModule {
  name: string = 'auth';

  configureServices(
    serviceProvider: IServiceProvider,
    configProvider: IAppConfigurationProvider
  ): void {
    this.registerMsal(serviceProvider, configProvider);
  }

  registerMsal(
    serviceProvider: IServiceProvider,
    configProvider: IAppConfigurationProvider
  ): void {
    const msalConfig = configProvider.getSection<MSalConfig>(
      'authentication.options'
    )!;
    const msalInstance = new PublicClientApplication(msalConfig);
    const loginApiRequest = {
      scopes: msalConfig.auth.scopes,
    };
    const msalTokeProvider = async () => {
      try {
        const account = msalInstance.getAllAccounts()[0];
        const msalResponse = await msalInstance.acquireTokenSilent({
          ...loginApiRequest,
          account: account,
        });
        const token = msalResponse.accessToken;
        return token; //"token" as any;
      } catch (e){
        const account = msalInstance.getActiveAccount();

        await msalInstance.logoutRedirect({
          account: account ?? undefined,
          logoutHint: account?.idTokenClaims?.login_hint as string | undefined,
          postLogoutRedirectUri: "/",
        });

        return Promise.reject(e);
      }
    };
    serviceProvider.register('msal-instance', msalInstance);
    serviceProvider.register('msal-token-provider', msalTokeProvider);
  }
}
